import { Level } from './types';

export const levels: { [key: number]: Level } = {
  1: {
    name: "Introduction",
    entities: [
      { type: 'PHANTOM', x: 2, y: 6 },
      { type: 'PORTAL', x: 17, y: 6 },
      { type: 'BARRIER', x: 9, y: 3 },
      { type: 'BARRIER', x: 10, y: 3 },
      { type: 'BARRIER', x: 11, y: 3 },
      { type: 'BARRIER', x: 9, y: 4 },
      { type: 'BARRIER', x: 11, y: 4 },
      { type: 'BARRIER', x: 9, y: 5 },
      { type: 'BARRIER', x: 11, y: 5 },
      { type: 'BARRIER', x: 9, y: 6 },
      { type: 'BARRIER', x: 11, y: 6 },
      { type: 'BARRIER', x: 9, y: 7 },
      { type: 'BARRIER', x: 10, y: 7 },
      { type: 'BARRIER', x: 11, y: 7 },
      { type: 'ORB', x: 5, y: 9 },
      { type: 'ORB', x: 15, y: 9 },
      { type: 'CRYSTAL', x: 10, y: 5 }
    ],
    wordBoxes: {
      2: [
        { type: 'WORD_PHANTOM', x: 1, y: 1 },
        { type: 'WORD_IS', x: 2, y: 1 },
        { type: 'WORD_YOU', x: 3, y: 1 },
        { type: 'WORD_PORTAL', x: 11, y: 1 },
        { type: 'WORD_IS', x: 12, y: 1 },
        { type: 'WORD_WIN', x: 13, y: 1 }
      ],
      3: [
        { type: 'WORD_BARRIER', x: 6, y: 1 },
        { type: 'WORD_IS', x: 7, y: 1 },
        { type: 'WORD_STOP', x: 8, y: 1 },
        { type: 'WORD_ORB', x: 1, y: 10 },
        { type: 'WORD_IS', x: 2, y: 10 },
        { type: 'WORD_PUSH', x: 3, y: 10 }
      ],
      4: [
        { type: 'WORD_CRYSTAL', x: 6, y: 10 },
        { type: 'WORD_IS', x: 7, y: 10 },
        { type: 'WORD_PHASE', x: 8, y: 10 }
      ]
    }
  },
  2: {
    name: "Barriers",
    entities: [
      { type: 'PHANTOM', x: 2, y: 6 },
      // Crystal barrier box (center-left)
      { type: 'BARRIER', x: 8, y: 4 },
      { type: 'BARRIER', x: 9, y: 4 },
      { type: 'BARRIER', x: 10, y: 4 },
      { type: 'BARRIER', x: 8, y: 5 },
      { type: 'BARRIER', x: 10, y: 5 },
      { type: 'BARRIER', x: 8, y: 6 },
      { type: 'BARRIER', x: 10, y: 6 },
      { type: 'BARRIER', x: 8, y: 7 },
      { type: 'BARRIER', x: 9, y: 7 },
      { type: 'BARRIER', x: 10, y: 7 },
      { type: 'CRYSTAL', x: 9, y: 5 },
      // Portal barrier box (right side)
      { type: 'BARRIER', x: 15, y: 4 },
      { type: 'BARRIER', x: 16, y: 4 },
      { type: 'BARRIER', x: 17, y: 4 },
      { type: 'BARRIER', x: 15, y: 5 },
      { type: 'BARRIER', x: 17, y: 5 },
      { type: 'BARRIER', x: 15, y: 6 },
      { type: 'BARRIER', x: 17, y: 6 },
      { type: 'BARRIER', x: 15, y: 7 },
      { type: 'BARRIER', x: 16, y: 7 },
      { type: 'BARRIER', x: 17, y: 7 },
      { type: 'PORTAL', x: 16, y: 6 }
    ],
    wordBoxes: {
      2: [
        { type: 'WORD_PHANTOM', x: 1, y: 1 },
        { type: 'WORD_IS', x: 2, y: 1 },
        { type: 'WORD_YOU', x: 3, y: 1 },
        { type: 'WORD_PORTAL', x: 11, y: 1 },
        { type: 'WORD_IS', x: 12, y: 1 },
        { type: 'WORD_WIN', x: 13, y: 1 }
      ],
      3: [
        { type: 'WORD_BARRIER', x: 6, y: 1 },
        { type: 'WORD_IS', x: 7, y: 1 },
        { type: 'WORD_STOP', x: 8, y: 1 },
        { type: 'WORD_CRYSTAL', x: 1, y: 10 },
        { type: 'WORD_IS', x: 2, y: 10 },
        { type: 'WORD_PHASE', x: 3, y: 10 }
      ],
      4: [
        { type: 'WORD_BARRIER', x: 6, y: 10 },
        { type: 'WORD_IS', x: 7, y: 10 },
        { type: 'WORD_PUSH', x: 8, y: 10 }
      ]
    }
  },
  3: {
    name: "Pushing",
    entities: [
      { type: 'PHANTOM', x: 2, y: 6 },
      { type: 'PORTAL', x: 17, y: 6 },
      { type: 'BARRIER', x: 9, y: 2 },
      { type: 'BARRIER', x: 10, y: 2 },
      { type: 'BARRIER', x: 11, y: 2 },
      { type: 'BARRIER', x: 9, y: 9 },
      { type: 'BARRIER', x: 10, y: 9 },
      { type: 'BARRIER', x: 11, y: 9 },
      { type: 'ORB', x: 5, y: 6 },
      { type: 'ORB', x: 15, y: 6 },
      { type: 'ROCK', x: 10, y: 6 }
    ],
    wordBoxes: {
      2: [
        { type: 'WORD_PHANTOM', x: 1, y: 1 },
        { type: 'WORD_IS', x: 2, y: 1 },
        { type: 'WORD_YOU', x: 3, y: 1 },
        { type: 'WORD_PORTAL', x: 11, y: 1 },
        { type: 'WORD_IS', x: 12, y: 1 },
        { type: 'WORD_WIN', x: 13, y: 1 }
      ],
      3: [
        { type: 'WORD_BARRIER', x: 6, y: 1 },
        { type: 'WORD_IS', x: 7, y: 1 },
        { type: 'WORD_STOP', x: 8, y: 1 },
        { type: 'WORD_ORB', x: 1, y: 10 },
        { type: 'WORD_IS', x: 2, y: 10 },
        { type: 'WORD_PUSH', x: 3, y: 10 }
      ],
      4: [
        { type: 'WORD_ROCK', x: 6, y: 10 },
        { type: 'WORD_IS', x: 7, y: 10 },
        { type: 'WORD_PUSH', x: 8, y: 10 }
      ]
    }
  },
  4: {
    name: "Phasing",
    entities: [
      { type: 'PHANTOM', x: 2, y: 6 },
      { type: 'PORTAL', x: 17, y: 6 },
      ...Array.from({ length: 11 }, (_, i) => ({ type: 'BARRIER', x: 5 + i, y: 2 })),
      ...Array.from({ length: 11 }, (_, i) => ({ type: 'BARRIER', x: 5 + i, y: 9 })),
      { type: 'CRYSTAL', x: 10, y: 6 }
    ],
    wordBoxes: {
      2: [
        { type: 'WORD_PHANTOM', x: 1, y: 1 },
        { type: 'WORD_IS', x: 2, y: 1 },
        { type: 'WORD_YOU', x: 3, y: 1 },
        { type: 'WORD_PORTAL', x: 11, y: 1 },
        { type: 'WORD_IS', x: 12, y: 1 },
        { type: 'WORD_WIN', x: 13, y: 1 }
      ],
      3: [
        { type: 'WORD_BARRIER', x: 6, y: 1 },
        { type: 'WORD_IS', x: 7, y: 1 },
        { type: 'WORD_STOP', x: 8, y: 1 },
        { type: 'WORD_CRYSTAL', x: 1, y: 10 },
        { type: 'WORD_IS', x: 2, y: 10 },
        { type: 'WORD_PHASE', x: 3, y: 10 }
      ],
      4: [
        { type: 'WORD_BARRIER', x: 6, y: 10 },
        { type: 'WORD_IS', x: 7, y: 10 },
        { type: 'WORD_PUSH', x: 8, y: 10 }
      ]
    }
  },
  5: {
    name: "Transformation",
    entities: [
      { type: 'PHANTOM', x: 2, y: 6 },
      { type: 'PORTAL', x: 17, y: 6 },
      { type: 'BARRIER', x: 9, y: 2 },
      { type: 'BARRIER', x: 10, y: 2 },
      { type: 'BARRIER', x: 11, y: 2 },
      { type: 'BARRIER', x: 9, y: 9 },
      { type: 'BARRIER', x: 10, y: 9 },
      { type: 'BARRIER', x: 11, y: 9 },
      { type: 'ROCK', x: 5, y: 6 },
      { type: 'ROCK', x: 15, y: 6 },
      { type: 'CRYSTAL', x: 10, y: 6 }
    ],
    wordBoxes: {
      2: [
        { type: 'WORD_PHANTOM', x: 1, y: 1 },
        { type: 'WORD_IS', x: 2, y: 1 },
        { type: 'WORD_YOU', x: 3, y: 1 },
        { type: 'WORD_PORTAL', x: 11, y: 1 },
        { type: 'WORD_IS', x: 12, y: 1 },
        { type: 'WORD_WIN', x: 13, y: 1 }
      ],
      3: [
        { type: 'WORD_BARRIER', x: 6, y: 1 },
        { type: 'WORD_IS', x: 7, y: 1 },
        { type: 'WORD_STOP', x: 8, y: 1 },
        { type: 'WORD_ROCK', x: 1, y: 10 },
        { type: 'WORD_IS', x: 2, y: 10 },
        { type: 'WORD_PUSH', x: 3, y: 10 }
      ],
      4: [
        { type: 'WORD_ROCK', x: 6, y: 10 },
        { type: 'WORD_IS', x: 7, y: 10 },
        { type: 'WORD_TRANSFORM', x: 8, y: 10 },
        { type: 'WORD_CRYSTAL', x: 9, y: 10 }
      ]
    }
  },
  6: {
    name: "Multiple Objects",
    entities: [
      { type: 'PHANTOM', x: 2, y: 6 },
      { type: 'PORTAL', x: 17, y: 6 },
      ...Array.from({ length: 11 }, (_, i) => ({ type: 'BARRIER', x: 5 + i, y: 2 })),
      ...Array.from({ length: 11 }, (_, i) => ({ type: 'BARRIER', x: 5 + i, y: 9 })),
      { type: 'ROCK', x: 10, y: 6 },
      { type: 'CRYSTAL', x: 3, y: 6 },
      { type: 'ORB', x: 16, y: 6 }
    ],
    wordBoxes: {
      2: [
        { type: 'WORD_PHANTOM', x: 1, y: 1 },
        { type: 'WORD_IS', x: 2, y: 1 },
        { type: 'WORD_YOU', x: 3, y: 1 },
        { type: 'WORD_PORTAL', x: 11, y: 1 },
        { type: 'WORD_IS', x: 12, y: 1 },
        { type: 'WORD_WIN', x: 13, y: 1 }
      ],
      3: [
        { type: 'WORD_BARRIER', x: 6, y: 1 },
        { type: 'WORD_IS', x: 7, y: 1 },
        { type: 'WORD_STOP', x: 8, y: 1 },
        { type: 'WORD_ROCK', x: 1, y: 10 },
        { type: 'WORD_IS', x: 2, y: 10 },
        { type: 'WORD_PUSH', x: 3, y: 10 }
      ],
      4: [
        { type: 'WORD_CRYSTAL', x: 6, y: 10 },
        { type: 'WORD_IS', x: 7, y: 10 },
        { type: 'WORD_PHASE', x: 8, y: 10 },
        { type: 'WORD_ORB', x: 9, y: 10 },
        { type: 'WORD_IS', x: 10, y: 10 },
        { type: 'WORD_DEFEAT', x: 11, y: 10 }
      ]
    }
  },
  7: {
    name: "Chain Reactions",
    entities: [
      { type: 'PHANTOM', x: 2, y: 6 },
      { type: 'PORTAL', x: 17, y: 6 },
      { type: 'BARRIER', x: 9, y: 2 },
      { type: 'BARRIER', x: 10, y: 2 },
      { type: 'BARRIER', x: 11, y: 2 },
      { type: 'BARRIER', x: 9, y: 9 },
      { type: 'BARRIER', x: 10, y: 9 },
      { type: 'BARRIER', x: 11, y: 9 },
      { type: 'ROCK', x: 5, y: 6 },
      { type: 'ROCK', x: 15, y: 6 },
      { type: 'WATER', x: 10, y: 6 },
      { type: 'FIRE', x: 10, y: 4 }
    ],
    wordBoxes: {
      2: [
        { type: 'WORD_PHANTOM', x: 1, y: 1 },
        { type: 'WORD_IS', x: 2, y: 1 },
        { type: 'WORD_YOU', x: 3, y: 1 },
        { type: 'WORD_PORTAL', x: 11, y: 1 },
        { type: 'WORD_IS', x: 12, y: 1 },
        { type: 'WORD_WIN', x: 13, y: 1 }
      ],
      3: [
        { type: 'WORD_BARRIER', x: 6, y: 1 },
        { type: 'WORD_IS', x: 7, y: 1 },
        { type: 'WORD_STOP', x: 8, y: 1 },
        { type: 'WORD_ROCK', x: 1, y: 10 },
        { type: 'WORD_IS', x: 2, y: 10 },
        { type: 'WORD_PUSH', x: 3, y: 10 }
      ],
      4: [
        { type: 'WORD_WATER', x: 6, y: 10 },
        { type: 'WORD_IS', x: 7, y: 10 },
        { type: 'WORD_SINK', x: 8, y: 10 },
        { type: 'WORD_FIRE', x: 9, y: 10 },
        { type: 'WORD_IS', x: 10, y: 10 },
        { type: 'WORD_HOT', x: 11, y: 10 }
      ]
    }
  },
  8: {
    name: "Contradictory Rules",
    entities: [
      { type: 'PHANTOM', x: 2, y: 6 },
      { type: 'PORTAL', x: 17, y: 6 },
      { type: 'BARRIER', x: 9, y: 2 },
      { type: 'BARRIER', x: 10, y: 2 },
      { type: 'BARRIER', x: 11, y: 2 },
      { type: 'BARRIER', x: 9, y: 9 },
      { type: 'BARRIER', x: 10, y: 9 },
      { type: 'BARRIER', x: 11, y: 9 },
      { type: 'ROCK', x: 5, y: 6 },
      { type: 'ROCK', x: 15, y: 6 },
      { type: 'CRYSTAL', x: 10, y: 6 }
    ],
    wordBoxes: {
      2: [
        { type: 'WORD_PHANTOM', x: 1, y: 1 },
        { type: 'WORD_IS', x: 2, y: 1 },
        { type: 'WORD_YOU', x: 3, y: 1 },
        { type: 'WORD_PORTAL', x: 11, y: 1 },
        { type: 'WORD_IS', x: 12, y: 1 },
        { type: 'WORD_WIN', x: 13, y: 1 }
      ],
      3: [
        { type: 'WORD_BARRIER', x: 6, y: 1 },
        { type: 'WORD_IS', x: 7, y: 1 },
        { type: 'WORD_STOP', x: 8, y: 1 },
        { type: 'WORD_BARRIER', x: 1, y: 10 },
        { type: 'WORD_IS', x: 2, y: 10 },
        { type: 'WORD_PUSH', x: 3, y: 10 }
      ],
      4: [
        { type: 'WORD_CRYSTAL', x: 6, y: 10 },
        { type: 'WORD_IS', x: 7, y: 10 },
        { type: 'WORD_PHASE', x: 8, y: 10 },
        { type: 'WORD_ROCK', x: 9, y: 10 },
        { type: 'WORD_IS', x: 10, y: 10 },
        { type: 'WORD_DEFEAT', x: 11, y: 10 }
      ]
    }
  },
  9: {
    name: "Complex Logic",
    entities: [
      { type: 'PHANTOM', x: 2, y: 6 },
      { type: 'PORTAL', x: 17, y: 6 },
      ...Array.from({ length: 11 }, (_, i) => ({ type: 'BARRIER', x: 5 + i, y: 2 })),
      ...Array.from({ length: 11 }, (_, i) => ({ type: 'BARRIER', x: 5 + i, y: 9 })),
      { type: 'KEY', x: 10, y: 6 },
      { type: 'DOOR', x: 17, y: 6 }
    ],
    wordBoxes: {
      2: [
        { type: 'WORD_PHANTOM', x: 1, y: 1 },
        { type: 'WORD_IS', x: 2, y: 1 },
        { type: 'WORD_YOU', x: 3, y: 1 },
        { type: 'WORD_PORTAL', x: 11, y: 1 },
        { type: 'WORD_IS', x: 12, y: 1 },
        { type: 'WORD_WIN', x: 13, y: 1 }
      ],
      3: [
        { type: 'WORD_BARRIER', x: 6, y: 1 },
        { type: 'WORD_IS', x: 7, y: 1 },
        { type: 'WORD_STOP', x: 8, y: 1 },
        { type: 'WORD_KEY', x: 1, y: 10 },
        { type: 'WORD_IS', x: 2, y: 10 },
        { type: 'WORD_PUSH', x: 3, y: 10 }
      ],
      4: [
        { type: 'WORD_DOOR', x: 6, y: 10 },
        { type: 'WORD_IS', x: 7, y: 10 },
        { type: 'WORD_SHUT', x: 8, y: 10 },
        { type: 'WORD_KEY', x: 9, y: 10 },
        { type: 'WORD_IS', x: 10, y: 10 },
        { type: 'WORD_OPEN', x: 11, y: 10 }
      ]
    }
  },
  10: {
    name: "Master Challenge",
    entities: [
      { type: 'PHANTOM', x: 2, y: 6 },
      { type: 'PORTAL', x: 17, y: 6 },
      ...Array.from({ length: 11 }, (_, i) => ({ type: 'BARRIER', x: 5 + i, y: 2 })),
      ...Array.from({ length: 11 }, (_, i) => ({ type: 'BARRIER', x: 5 + i, y: 9 })),
      { type: 'ROCK', x: 5, y: 6 },
      { type: 'ROCK', x: 15, y: 6 },
      { type: 'WATER', x: 10, y: 6 },
      { type: 'FIRE', x: 10, y: 4 },
      { type: 'KEY', x: 8, y: 6 },
      { type: 'DOOR', x: 12, y: 6 },
      { type: 'CRYSTAL', x: 3, y: 6 },
      { type: 'ORB', x: 16, y: 6 }
    ],
    wordBoxes: {
      2: [
        { type: 'WORD_PHANTOM', x: 1, y: 1 },
        { type: 'WORD_IS', x: 2, y: 1 },
        { type: 'WORD_YOU', x: 3, y: 1 },
        { type: 'WORD_PORTAL', x: 11, y: 1 },
        { type: 'WORD_IS', x: 12, y: 1 },
        { type: 'WORD_WIN', x: 13, y: 1 }
      ],
      3: [
        { type: 'WORD_BARRIER', x: 6, y: 1 },
        { type: 'WORD_IS', x: 7, y: 1 },
        { type: 'WORD_STOP', x: 8, y: 1 },
        { type: 'WORD_ROCK', x: 1, y: 10 },
        { type: 'WORD_IS', x: 2, y: 10 },
        { type: 'WORD_PUSH', x: 3, y: 10 },
        { type: 'WORD_WATER', x: 4, y: 10 },
        { type: 'WORD_IS', x: 5, y: 10 },
        { type: 'WORD_SINK', x: 6, y: 10 }
      ],
      4: [
        { type: 'WORD_FIRE', x: 6, y: 10 },
        { type: 'WORD_IS', x: 7, y: 10 },
        { type: 'WORD_HOT', x: 8, y: 10 },
        { type: 'WORD_KEY', x: 9, y: 10 },
        { type: 'WORD_IS', x: 10, y: 10 },
        { type: 'WORD_OPEN', x: 11, y: 10 },
        { type: 'WORD_DOOR', x: 12, y: 10 },
        { type: 'WORD_IS', x: 13, y: 10 },
        { type: 'WORD_SHUT', x: 14, y: 10 }
      ]
    }
  }
};
